const eventBus = window.theme.tagalys.searchAutocomplete.eventBus;

class SearchAutoCompleteStateLayer {
  constructor() {
    this.props = {
      productsLimit: 4,
      keywordsLimit: 10,
    }

    this.state = {
      keywords: [],
      products: [],
      popular: [],
      collections: [],
      term: ''
    };

    this.subscribeToEvents();
  }

  subscribeToEvents() {
    eventBus.subscribe('searchAutoComplete:ui:term:updated', (response) => {
      const { term } = response;
      this.term = term;
    });

    eventBus.subscribe('searchAutoComplete:api:results:fetched', (response) => {
      this.products = response?.sections?.products?.items ?? [];
      this.keywords = response?.sections?.searches?.items ?? [];

      eventBus.publish('searchAutoComplete:state:updated', this.state);
    });

    eventBus.subscribe('searchAutoComplete:api:initial:fetched', (response) => {
      this.popular = response;

      eventBus.publish('searchAutoComplete:state:initial:updated', this.state.popular);
    });
  }

  set term(term) {
    this.state.term = term;
    eventBus.publish('searchAutoComplete:state:term:updated', term);
  }

  set keywords(keywords) {
    this.state.keywords = keywords;
  }

  set products(products) {
    this.state.products = products;
  }

  set popular(popular) {
    this.state.popular = popular;
  }

  get term() {
    return this.state.term;
  }

  get keywords() {
    return this.state.keywords;
  }

  get products() {
    return this.state.products;
  }

  get popular() {
    return this.state.popular;
  }

}

window.theme.tagalys.searchAutocomplete.stateLayer = new SearchAutoCompleteStateLayer();
